import React, { Fragment, FunctionComponent } from "react";
import styles from "./SocialLinks.module.scss";
import SocialLinksProps from "./SocialLinksProps.interface";

import Anchor from "components/Anchor/Anchor";
import IconViewer from "components/IconViewer/IconViewer";
import combineClasses from "helpers/combine-classes";

const SocialLinks: FunctionComponent<SocialLinksProps> = (props) => {
  const iconSizeClass = props?.theme?.socialIconSize
    ? styles[`${props.theme.socialIconSize.toLowerCase()}`]
    : "small";
  return (
    <div className={combineClasses(styles.wrapper, iconSizeClass)}>
      {/* Social links */}
      {props?.enableSectionSocialLinks ? (
        <>
          {/* Facebook */}
          {props.socialFacebookUrl && props.socialFacebookUrl !== "" ? (
            <Anchor className={styles.link} to={props.socialFacebookUrl}>
              <IconViewer className={styles.icon} name="facebook" />
            </Anchor>
          ) : null}

          {/* Instagram */}
          {props.socialInstagramUrl && props.socialInstagramUrl !== "" ? (
            <Anchor className={styles.link} to={props.socialInstagramUrl}>
              <IconViewer className={styles.icon} name="instagram" />
            </Anchor>
          ) : null}

          {/* Linkedin */}
          {props.socialLinkedinUrl && props.socialLinkedinUrl !== "" ? (
            <Anchor className={styles.link} to={props.socialLinkedinUrl}>
              <IconViewer className={styles.icon} name="linkedin" />
            </Anchor>
          ) : null}

          {/* Twitter */}
          {props.socialTwitterUrl && props.socialTwitterUrl !== "" ? (
            <Anchor className={styles.link} to={props.socialTwitterUrl}>
              <IconViewer className={styles.icon} name="twitter" />
            </Anchor>
          ) : null}

          {/* YouTube */}
          {props.socialYoutubeUrl && props.socialYoutubeUrl !== "" ? (
            <Anchor className={styles.link} to={props.socialYoutubeUrl}>
              <IconViewer className={styles.icon} name="youtube" />
            </Anchor>
          ) : null}
        </>
      ) : null}

      {/* Social Icons */}
      {props.socialIconList && props.enableSocialIconsList ? (
        <>
          {/* Icons */}
          {props.socialIconList.length > 0 ? (
            <>
              {props.socialIconList.map((item: any) => {
                return (
                  <Fragment key={item.contentUdi}>
                    <Anchor className={styles.link} to={item.content.link}>
                      {item.content.icon ? (
                        <IconViewer
                          className={styles.icon}
                          name={`${item.content.icon}`.toLowerCase()}
                        />
                      ) : null}
                    </Anchor>
                  </Fragment>
                );
              })}
            </>
          ) : null}
        </>
      ) : null}
    </div>
  );
};

export default SocialLinks;
